import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Input, Header, Icon, Label } from 'semantic-ui-react'

import 'react-datepicker/dist/react-datepicker.css';

class FormsInputsTime extends Component {
    state = {
        startDate: (this.props.field) ? this.props.field.value : moment()
    }

    handleChange(date) {
        this.setState({
            startDate: date
        });
        this.props.form.setFieldValue(this.props.field.name, date)
    }

    render() {
        const {
            label,
            maxTime,
            minTime
        } = this.props;
        return (
            <div className="field">
                <>
                    <Header as='h5'>{label}</Header>
                </>
                <DatePicker
                    customInput={<Input labelPosition="right" label={<Label><Icon name="calendar alternate outline"/></Label>} />}
                    selected={this.state.startDate}
                    onChange={this.handleChange.bind(this)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    dateFormat="LT"
                    timeCaption="Time"
                    maxTime={ maxTime }
                    minTime={ minTime }
                />
            </div>
        );
    }
}

export default FormsInputsTime;
